import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  makeStyles,
  Grid,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AnyAction } from "redux";
import { submitReturn } from "../../../redux/actions";
import {
  authSelector,
  dataPortalLookupListSelector,
} from "../../../redux/selectors";
import { sasTokenService } from "../../../services";
import { FileService } from "../../../services/FileService";

type UploadDialogProps = {
  file: File | undefined;
  onClose: () => void;
  open: boolean;
  index: string;
  templateName: string;
  setLoading: React.Dispatch<any>;
  setLoaded: React.Dispatch<any>;
  templateId: number | null;
  collectionAoId: number | null;
};
const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: 15,
  },
  body: {
    marginTop: 5,
    marginBottom: 5,
  },
  unassignBtn: {
    marginRight: "auto",
  },
}));

export const FileUploadDialog: React.FC<UploadDialogProps> = ({
  onClose,
  file,
  open,
  index,
  setLoading,
  setLoaded,
  templateName,
  templateId,
  collectionAoId,
}) => {
  const classes = useStyles();
  const { orgId } = useSelector(dataPortalLookupListSelector);
  const { token } = useSelector(authSelector);
  const dispatch = useDispatch();

  const progressCallback = (file: File, fileName: string) => (p: any) => {
    if (file !== undefined) {
      const percent = Math.floor((p.loadedBytes / file.size) * 100);
      console.log(
        `Approx. ${percent}% loaded (${p.loadedBytes / 1024} out of ${
          file.size / 1024
        } KB)`
      );
      if (percent === 100) {
        setLoaded((prevState: any) => {
          return { ...prevState, [index]: true };
        });
        if (collectionAoId === null || templateId === null) {
          throw new Error("Template ID or Collection AO ID has not been set");
        } else {
          dispatch(submitReturn(fileName, collectionAoId, templateId));
        }
      }
      setLoading((prevState: any) => {
        return { ...prevState, [index]: percent };
      });
    }
  };
  const onSubmit = () => {
    setLoading((prevState: any) => {
      return {
        ...prevState,
        [index]: 0,
      };
    });
    sasTokenService
      .get({ orgId, templateName, fileName: file?.name }, { token: token })
      .then((res) => {
        new FileService().uploadFileToFileService(file!, res.sasUri, (p: any) =>
          progressCallback(file!, res.timestampedFileName)(p)
        );
      });

    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="upload-file-dialog"
    >
      <>
        <DialogTitle data-test="upload-file-dialog-title">
          File upload confirmation
          <Divider />
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="body1">
                Are you sure you want to submit this file?
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={onClose}
            color="primary"
            data-test="close-upload-button"
          >
            Close
          </Button>
          <Button
            onClick={onSubmit}
            color="primary"
            data-test="confirm-upload-button"
          >
            Confirm
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
};
